export default {
  path: '/employees',
  component: () => import('@/views/employees/Index'),
  redirect: { name: 'employees-list' },
  children: [
    {
      path: 'employees',
      component: () => import('@/views/employees/employees/Index'),
      children: [
        {
          path: '',
          name: 'employees-list',
          component: () => import('@/views/employees/employees/List'),
          meta: {
            title: 'List of employees',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/employees/employees/detail/Layout'),
          children: [
            {
              path: '',
              name: 'employees-profile',
              component: () => import('@/views/employees/employees/detail/Profile'),
              meta: {
                title: 'Employee profile',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'documents',
              name: 'employees-documents',
              component: () => import('@/views/employees/employees/detail/Documents'),
              meta: {
                title: 'Employee documents',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'contracts-salaries',
              name: 'employees-contracts-salaries',
              component: () => import('@/views/employees/employees/detail/ContractsSalaries'),
              meta: {
                title: 'Employee contracts & salaries',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'other',
              name: 'employees-other',
              component: () => import('@/views/employees/employees/detail/Other'),
              meta: {
                title: 'Other',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'biometry',
              name: 'employees-biometry',
              component: () => import('@/views/employees/employees/detail/Biometry'),
              meta: {
                title: 'Biometry',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'calculation',
              name: 'employees-calculation',
              component: () => import('@/views/employees/employees/detail/Calculation'),
              meta: {
                title: 'Calculation',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'comments',
              name: 'employees-comments',
              component: () => import('@/views/employees/employees/detail/Comments'),
              meta: {
                title: 'Comments',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'utt',
              name: 'employees-utt',
              component: () => import('@/views/employees/employees/detail/UTT'),
              meta: {
                title: 'UTT',
                roles: ['general_manager']
              }
            },
          ]
        },
      ]
    },
    {
      path: 'warnings',
      component: () => import('@/views/employees/warnings/Index'),
      children: [
        {
          path: '',
          name: 'employees-warnings',
          component: () => import('@/views/employees/warnings/List'),
          meta: {
            title: 'Warnings',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
      ]
    },
    {
      path: 'advances',
      component: () => import('@/views/employees/advances/Index'),
      children: [
        {
          path: '',
          name: 'employees-advances',
          component: () => import('@/views/employees/advances/List'),
          meta: {
            title: 'Advances',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
      ]
    },
    {
      path: 'payroll',
      component: () => import('@/views/employees/payroll/Index'),
      children: [
        {
          path: '',
          name: 'employees-payroll-list',
          component: () => import('@/views/employees/payroll/List'),
          meta: {
            title: 'Payrolls',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/employees/payroll/Layout'),
          children: [
            {
              path: '',
              name: 'employees-payroll-employees',
              component: () => import('@/views/employees/payroll/Employees'),
              meta: {
                title: 'Payroll',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
              }
            },
            {
              path: 'downloads',
              name: 'employees-payroll-downloads',
              component: () => import('@/views/employees/payroll/Downloads'),
              meta: {
                title: 'Downloads',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
              }
            },
          ]
        }
      ]
    },
    {
      path: 'utt-balance',
      name: 'employees-utt-balance',
      component: () => import('@/views/employees/UTTBalance'),
      meta: {
        title: 'UTT Balance',
        roles: ['general_manager']
      }
    },
    {
      path: 'contract-renewals',
      name: 'employees-contract-renewals',
      component: () => import('@/views/employees/ContractRenewals'),
      meta: {
        title: 'Contract renewals',
        roles: ['general_manager', 'hr_manager', 'hr_supervisor']
      }
    },
    {
      path: 'dashboard',
      name: 'employees-dashboard',
      component: () => import('@/views/employees/Dashboard'),
      meta: {
        title: 'Employee dashboard',
        roles: ['general_manager', 'hr_manager', 'hr_supervisor']
      }
    },
    {
      path: 'leaves',
      name: 'employees-leaves',
      component: () => import('@/views/employees/Leaves'),
      meta: {
        title: 'Employee leaves',
        roles: ['general_manager', 'hr_manager', 'sales_supervisor', 'sales_manager']
      }
    },
    {
      path: 'analytics',
      component: () => import('@/views/employees/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'employees-analytics',
          component: () => import('@/views/employees/analytics/Summary'),
          meta: {
            title: 'Employee analytics',
            roles: ['general_manager']
          }
        },
        {
          path: 'compensation',
          name: 'employees-analytics-compensation',
          component: () => import('@/views/employees/analytics/Compensation'),
          meta: {
            title: 'Employee analytics',
            roles: ['general_manager']
          }
        }
      ]
    }
  ]
}